export default {"src":"/_next/static/media/car_animation.2257da23.webp","height":173,"width":250,"blurWidth":0,"blurHeight":0};